export default __webpack_public_path__ + "static/media/company_wide_pie_chart.c3b4cf70.jpg";